import Head from 'next/head';
import React from 'react';

const VIEWPORT_NAME = 'viewport';
const DEFAULT_CONTENT_VALUE =
  'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, shrink-to-fit=no';

type ViewportHeadProps = {
  content?: string;
};

/**
 * Viewport Head Component
 * @param {string} content
 */
function ViewportHead({ content = DEFAULT_CONTENT_VALUE }: ViewportHeadProps) {
  return (
    <Head>
      <meta name={VIEWPORT_NAME} content={content} key={VIEWPORT_NAME} />
    </Head>
  );
}

export default React.memo(ViewportHead);
